/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1DocumentObjectStringEnum {
  'DocumentObjectTypeTextString' = 'text',
  'DocumentObjectTypeImgCameraString' = 'img_camera',
  'DocumentObjectTypeDateString' = 'date',
  'DocumentObjectTypeEmailString' = 'email',
  'DocumentObjectTypeTextDigitString' = 'text_digit',
  'DocumentObjectTypeImgGalleryString' = 'img_gallery',
  'DocumentObjectTypeDropdownListString' = 'dropdown_list',
  'DocumentObjectTypePDFString' = 'pdf',
  'DocumentObjectTypeUnknownString' = 'unknown',
}

export type V1DocumentObjectString = V1DocumentObjectStringEnum